<h2 mat-dialog-title>{{'sessionTimeout.title'|translate}}</h2>
<mat-dialog-content>
  <p class="draft">{{'sessionTimeout.message'|translate}}</p>
  <mat-dialog-actions>
    <button class="publishPopUpBtn conf-btn" cdkFocusInitial (click)="onReLogin()">{{'button.reLogin'|translate}}</button>
  </mat-dialog-actions>
</mat-dialog-content>
